import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';
import Input from './Input';

const StickyHeader = ({ 
  onSearchQuery = () => {}, 
  searchQuery = '', 
  showSearch = true,
  showAddContact = true,
  onAddContact = () => {},
  onSettingsClick = () => {},
  className = ''
}) => {
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  const handleSearchChange = (e) => {
    onSearchQuery(e?.target?.value);
  };

  return (
    <header className={`sticky top-0 z-200 bg-surface border-b border-border shadow-card ${className}`}>
      <div className="flex items-center justify-between h-14 lg:h-16 px-4 lg:px-6">
        {/* Logo Section */}
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 lg:w-10 lg:h-10 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Users" size={20} color="white" className="lg:w-6 lg:h-6" />
            </div>
            <div className="hidden sm:block">
              <h1 className="text-lg lg:text-xl font-semibold text-text-primary">
                ContactSync Pro
              </h1>
            </div>
          </div>
        </div>

        {/* Search Section - Desktop */}
        {showSearch && (
          <div className="hidden md:flex flex-1 max-w-md mx-6">
            <div className="relative w-full">
              <Input
                type="search"
                placeholder="Search contacts..."
                value={searchQuery}
                onChange={handleSearchChange}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => setIsSearchFocused(false)}
                className="pl-10"
              />
              <Icon 
                name="Search" 
                size={18} 
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary" 
              />
            </div>
          </div>
        )}

        {/* Actions Section */}
        <div className="flex items-center space-x-2 lg:space-x-3">
          {/* Mobile Search Toggle */}
          {showSearch && (
            <Button
              variant="ghost"
              size="icon"
              className="md:hidden"
              onClick={() => {}}
            >
              <Icon name="Search" size={20} />
            </Button>
          )}

          {/* Add Contact Button */}
          {showAddContact && (
            <Button
              variant="default"
              size="sm"
              onClick={onAddContact}
              iconName="Plus"
              iconPosition="left"
              className="hidden sm:flex"
            >
              Add Contact
            </Button>
          )}

          {/* Mobile Add Contact */}
          {showAddContact && (
            <Button
              variant="default"
              size="icon"
              onClick={onAddContact}
              className="sm:hidden"
            >
              <Icon name="Plus" size={20} />
            </Button>
          )}

          {/* Settings */}
          <Button
            variant="ghost"
            size="icon"
            onClick={onSettingsClick}
          >
            <Icon name="Settings" size={20} />
          </Button>
        </div>
      </div>

      {/* Mobile Search Bar - Expandable */}
      {showSearch && isSearchFocused && (
        <div className="md:hidden px-4 pb-3 border-t border-border bg-surface">
          <div className="relative">
            <Input
              type="search"
              placeholder="Search contacts..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="pl-10"
              autoFocus
            />
            <Icon 
              name="Search" 
              size={18} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary" 
            />
          </div>
        </div>
      )}
    </header>
  );
};

export default StickyHeader;